<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-29 15:59:26
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-30 15:17:07
 * @FilePath: \sns-user-frontend\src\components\web\share.vue
 * @Description: 分享弹窗
-->
<template>
  <div class="social-share">
    <el-dialog 
      class="share-dialog"
      v-model="visible" 
      align-center
      :show-close="false"
      :modal="false"
      @close="onClose"
      :append-to-body="true"
      :z-index="zIndex"
    >
      <template #header>
        <p class="title">{{$t('share')}}</p>
      </template>
      <div class="main" v-if="!isChina">
        <div class="social-icon">
          <svg-icon 
            name="icon-share-facebook"
            @click="onShare('facebook')"
          />
          <svg-icon 
            name="icon-share-twitter"
            @click="onShare('twitter')"
          />
        </div>
        <p>OR COPY LINK</p>
      </div>
      <template #footer>
        <div class="footer">
          <div class="share-link">
            {{ shareLink }}
          </div>
          <button @click="onShare()">{{$t('copy')}}</button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import XssFilter from '@/utils/xssFilter'
import { copyText } from '@/utils'

const route = useRoute()
const { proxy } = getCurrentInstance()

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  info: {
    type: Object,
    default: () => {}
  },
  link: {
    type: String,
    default: location.href
  },
  bindUrl: {
    type: String,
    default: ''
  },
  zIndex: {
    type: Number
  },
})

// 弹窗开关
const visible = ref(false)
// 分享链接
const shareLink = ref('')
const isChina = ref(import.meta.env.VITE_COUNTRY === 'CHINA')
// 开关同步
watch(() => props.modelValue, (val) => {
  visible.value = val
}, {
  immediate: true
})

// 链接同步
watch(() => props.bindUrl, (val) => {
  shareLink.value = val
}, { immediate: true, deep: true})


// 关闭
const onClose = () => {
  visible.value = false
  emit('update:modelValue', false)
}

// 点击分享
const onShare = (type) => {
  proxy.$ga('share', {
    "screen_name": route.name,
    "item_id": `${props.info?.type === 1 ? 'Article' : (props.info?.type === 2 ? 'Moment' : 'Poll')} + ${route.params.id}`,
    "content_type": 'Thread',
    "button_name": type || 'Copy Link',
    "circleId": props.info?.circleBasicInfo?.id,
    "author_id": props.info?.publishUserInfo?.uid
  })
  let url = ''
  switch (type) {
    case 'facebook':
      url = `http://www.facebook.com/sharer.php?u=${encodeURIComponent(props.bindUrl ? props.bindUrl : location.href)}`
      break
    case 'twitter':
      url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(props.bindUrl ? props.bindUrl : location.href)}`
      break
    default:
      copyText(shareLink.value).then(res => {
        proxy.$toast({
          message:  proxy.$t('copyToast'),
          duration: 2000,
        })
      })
  }
  if (type === 'facebook' || type === 'twitter') {
    window.open(url, "_blank", "toolbar=yes, location=yes,  directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350");
  }
}

watch(() => props.info, (val) => {
  // setTimeout(() => {
    let { subject, content } = val || {}
    if (subject) {
      subject = `${subject.substring(0, 100)}${subject.length > 100 ? '...' : ''}`
    } else {
      let div = document.createElement('div')
      div.innerHTML = XssFilter(content)
      content = div.innerText
      content = `${content.substring(0, 100)}${content.length > 100 ? '...' : ''}`
    }
    let shareContent =''
    if(subject || content){
      shareContent = ` [${subject?.trim() || content?.trim()}]`
    }
    shareLink.value = `${props.bindUrl ? props.bindUrl : location.href}${shareContent}`
  // }, 500);  
}, {
  immediate: true,
  deep: true
})
</script>

<style lang="postcss" scoped>
.social-share {
  :deep(.el-dialog) {
    --el-dialog-width: auto;
    --el-border-radius-small: 24px;
    max-width: 50%;
    min-width: 432px;
    .el-dialog__header {
      padding: 0;
      margin-right: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
      text-align: center;
    }
  }
}
.title {
  font-size: 24px;
  line-height: 120%;
  padding: 48px 0;
  text-align: center;
}
.main {
    
  .social-icon {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 48px;
    .svg-icon {
      width: 48px;
      height: 48px;
      &:first-child {
        margin-right: 48px;
      }
    }
  }
  p {
    font-size: 14px;
    font-family: 'orbit-M';
    color: var(--text-secondary);
    margin-bottom: 16px;
    text-align: center;
  }
}
.footer {
  margin-bottom: 60px;
  .share-link {
    font-size: 14px;
    color: var(--text-secondary);
    margin: 0 48px ;
    padding: 12px 46px 8px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    word-break: break-word;
  }
  button {
    font-size: 14px;
    margin-top: 20px;
    color: var(--theme);
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
}
</style>

<style lang="postcss">
.share-dialog {
  --el-dialog-width: auto;
  --el-border-radius-small: 24px;
  max-width: 50%;
  min-width: 432px;
  .el-dialog__header {
    padding: 0;
    margin-right: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
  }
}
</style>